<template>
  <div>
    <div class="partners-barchart-buttons">
      <div
        v-for="(chart, index) in chartData"
        :key="index"
        class="partners-barchart-button"
        :class="{'partners-barchart-button--selected': currentChartIndex == index}"
        @click="currentChartIndex = index"
      >
        <fa-icon
          icon="square"
          class="mr-2"
          :style="{color: colors[index]}"
        />
        <span>{{ chart.title }}</span>
      </div>
    </div>
    <BarChart
      :height="300"
      :chart-data="currentChart"
      :options="options"
    />
  </div>
</template>

<script>
import BarChart from './BarChart.vue';
import CONFIG from '../../config';

export default {
    name: 'DistributionBarChart',
    components: {
        BarChart,
    },
    props: {
        chartData: {
            type: Array,
            required: true,
        },
        colors: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            currentChartIndex: 0,
        };
    },
    computed: {
        currentChart() {
            if (this.chartData[this.currentChartIndex]) {
                return this.chartData[this.currentChartIndex];
            }
            return {};
        },
    },
    methods: {
        color(title) {
            return CONFIG.COLORS.partners[title];
        },
    },
};
</script>
<style lang="scss">
.partners-barchart-buttons {
    margin-bottom: 1rem;
}
.partners-barchart-button {
    margin-right: 1rem;
    cursor: pointer;
    text-align: left;
    @media only screen and (min-width: 600px) {
        display: inline-block;
    }

    span {
        opacity: 0.3;
        transition: all 0.2s;
    }
}
.partners-barchart-button--selected {
    span {
        opacity: 1;
    }
}
</style>
